import { AppState } from "../features/setup/appRootReducer";
import { FetchParams, Middleware, RequestContext } from "./runtime";
import { store } from "../App";

export const authMiddleware: Middleware = {
    pre: async (context: RequestContext) => {
      
        const headers = context.init.headers as { [key: string]: string };
        const appState = store.getState() as AppState;
        const basic = appState.basic;
      
        headers["Authorization"] = 'Bearer ' + basic.accessToken;
        const params: FetchParams = {
            url: context.url,
            init: { ...context.init, headers: headers }
        };
        return Promise.resolve(params);
    }
  };